import UserOpinion from './UserOpinion.svelte';

window.loadOpinions = () => {
	// find all opinions on page:
	document.querySelectorAll("[data-opinion-pid]").forEach((el) => {
		const opinion = new UserOpinion({
			target: el,
			props: {
				pid: el.getAttribute('data-opinion-pid'),
				uid: el.getAttribute('data-opinion-uid')
			}
		});
	})

}

export default app;